/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Plain_Wallaby_EnrichInputs */

const en_chunky_plain_wallaby_enrich = /** @type {(inputs: Chunky_Plain_Wallaby_EnrichInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dripping...`)
};

/**
* | output |
* | --- |
* | "Dripping..." |
*
* @param {Chunky_Plain_Wallaby_EnrichInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chunky_plain_wallaby_enrich = /** @type {((inputs?: Chunky_Plain_Wallaby_EnrichInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Plain_Wallaby_EnrichInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_chunky_plain_wallaby_enrich(inputs)
});